import React from "react";
import FunctionDefinedComponents, {RolledChildType} from "../handler-components/FunctionDefinedComponents";
import {OrderContextValues} from "../../contexts/OrderContext";
import * as Navigator from "../../refrences/RootNavigation";
import {storageFunctions} from "../../storage";

interface state {
}

interface props {
    event: any,
    origin: "browser" | "manual"
    children: any
}

export default class PWAInstallPromptComponents extends FunctionDefinedComponents <props, state> {

    constructor(props: any) {
        super(props);
    }

    understand() {
        Navigator.goBack();
        if (this.props.event != null)
            this.props.event.prompt();
        if (this.props.origin == "manual")
            storageFunctions.saveData("pwa_manual_installation_showed", "true");
    }

    rolledChildren(): RolledChildType {
        return [
            {
                role: "install-text",
                visible: true,
                props: {},
                children: this.props.origin == "browser" ? "برای نصب، در مرحله بعد روی دکمه «نصب» یا Install کلیک کنید" :
                        "برای نصب، از منوی مرورگر گزینه «افزودن به صفحه اصلی» یا Add to homescreen را انتخاب کنید."

            },
            {
                role: "aths-image",
                visible: this.props.origin == "manual",
                props: {
                    source: {uri: "https://storage.meezban.net/aths_shot.jpg"}
                },
                children: null
            },
            {
                role: "understand-button",
                visible: true,
                props: {
                    title: "متوجه شدم",
                    onPress: () => {
                        this.understand();
                    }
                },
                children: null
            },
        ];
    }

}
